import { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { v4 as uuid } from 'uuid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import { Images } from 'assets/images';
import {
  ANSWER_DATA,
  OFF,
  ANSWER_OPTIONS,
  REACT_HOOK_FORM_NAMES,
} from 'admin/utils/contants';
import { InputWithLabel } from 'admin/components/Users/styled';
import {
  ModalWrapper,
  ModalSampleField,
  AddAnswer,
  SaveButton,
  StyledSelect,
  ListItem,
  CloseModalIcon,
  CloseIcon,
  SampleImage,
  ImagesWrapper,
} from './styled';

export const CreateQuestionModal = ({
  setQuestionsData,
  showAnswerCreateModal,
  questionsData,
}) => {
  const { register, control, handleSubmit } = useForm();
  const [answers, setAnswers] = useState(ANSWER_DATA);
  const [eyeIcons, setEyeIcons] = useState([]);
  const [answerNumber, setAnswerNumber] = useState(0);

  const addAnswers = (e) => {
    e.preventDefault();
    setAnswerNumber(answerNumber + 1);
    setAnswers((prev) => [
      ...prev,
      {
        labelKey: 'label Key',
        labelValue: 'label Value',
        id: answerNumber + 1,
        password_eye: false,
      },
    ]);
  };

  const deleteAnswer = (id) => {
    setAnswers(() => answers.filter((item) => item.id !== id));
  };

  const onSubmit = (data) => {
    setQuestionsData((prev) => [
      ...prev,
      {
        id: questionsData?.length + 1,
        title: data.title,
        position: data.position,
        visibility: OFF,
        answer_type: data.answer_type,
        password_eye: false,
      },
    ]);
    showAnswerCreateModal();
  };

  const toggleEyeIcon = (id) => {
    if (eyeIcons.includes(id)) {
      setEyeIcons(() => eyeIcons.filter((item) => item !== id));
    } else {
      setEyeIcons((prev) => [...prev, id]);
    }
  };

  return (
    <ModalWrapper onSubmit={handleSubmit(onSubmit)}>
      <CloseModalIcon src={Images.closeBlueIcon} onClick={showAnswerCreateModal} />
      <ModalSampleField>
        <Controller
          name={REACT_HOOK_FORM_NAMES.question}
          control={control}
          render={({ field }) => (
            <InputWithLabel
              id="outlined-basic"
              label="Question"
              {...register(REACT_HOOK_FORM_NAMES.title)}
              onChange={field.onChange}
              key={field.key}
              variant="outlined"
            />
          )}
        />
      </ModalSampleField>
      <ModalSampleField>
        <Controller
          name={REACT_HOOK_FORM_NAMES.position}
          control={control}
          render={({ field }) => (
            <InputWithLabel
              id="outlined-basic"
              label="Position"
              {...register(REACT_HOOK_FORM_NAMES.position)}
              onChange={field.onChange}
              key={field.key}
              variant="outlined"
              type="number"
            />
          )}
        />
      </ModalSampleField>
      <ModalSampleField select>
        <Controller
          control={control}
          name={REACT_HOOK_FORM_NAMES.answer_type}
          render={({ field }) => (
            <Box>
              <FormControl>
                <InputLabel id="demo-simple-select-label">Answer Type</InputLabel>
                <StyledSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Answer Type"
                  onChange={field.onChange}
                  selected={field.value}
                  inputProps={{
                    autocomplete: 'new-password',
                    form: {
                      autocomplete: 'off',
                    },
                  }}
                  options={ANSWER_OPTIONS}
                  placeholder="Answer Type"
                >
                  <ListItem value={ANSWER_OPTIONS.checkbox}>
                    {ANSWER_OPTIONS.checkbox}
                  </ListItem>
                  <ListItem value={ANSWER_OPTIONS.multiple_choice}>
                    {ANSWER_OPTIONS.multiple_choice}
                  </ListItem>
                  <ListItem value={ANSWER_OPTIONS.calendar}>
                    {ANSWER_OPTIONS.calendar}
                  </ListItem>
                  <ListItem value={ANSWER_OPTIONS.item_counter}>
                    {ANSWER_OPTIONS.item_counter}
                  </ListItem>
                  <ListItem value={ANSWER_OPTIONS.dropDown}>
                    {ANSWER_OPTIONS.dropDown}
                  </ListItem>
                </StyledSelect>
              </FormControl>
            </Box>
          )}
        />
      </ModalSampleField>
      {answers?.map((element) => (
        <ModalSampleField isLabel key={uuid()} id={element.id}>
          <Controller
            name={REACT_HOOK_FORM_NAMES.label_key}
            control={control}
            render={({ field }) => (
              <InputWithLabel
                id="outlined-basic"
                label="Answer Option"
                {...register(`${REACT_HOOK_FORM_NAMES.label_key}:${element.id}`)}
                onChange={field.onChange}
                key={field.key}
                variant="outlined"
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                type="text"
              />
            )}
          />
          <ImagesWrapper>
            <CloseIcon
              src={
                eyeIcons.includes(element.id)
                  ? Images.eyeClosedSilverEye
                  : Images.eyeIcon
              }
              isCloseEye={eyeIcons.includes(element.id) ? null : true}
              onClick={() => toggleEyeIcon(element.id)}
            />
            <SampleImage
              action
              src={Images.closeSilverIcon}
              onClick={() => deleteAnswer(element.id)}
            />
          </ImagesWrapper>
        </ModalSampleField>
      ))}
      <AddAnswer onClick={addAnswers}>+ Add Another</AddAnswer>

      <SaveButton>Save</SaveButton>
    </ModalWrapper>
  );
};
